import * as React from 'react';
import {

    List,
    Datagrid,
    TextField,
    NumberField,
    ImageField, EditButton, ReferenceField,
} from 'react-admin';
import FormattedDateTimeField from "../../common/FormattedDateTimeField";
import {SoftDeleteWithDialogAction} from "../../common/SoftDeleteWithDialogAction";

const DownloadList = () => {
    return (
        <List
            sort={{field: 'display_order', order: 'ASC'}}>
            <Datagrid>
                <ImageField source={'thumbnail'}/>
                <TextField source="title"/>
                <NumberField source={'display_order'}/>
                <FormattedDateTimeField source="created_at"/>
                
                <ReferenceField reference={'download_categories'} source={'category_id'} >
                    <TextField source={'name'}/>
                </ReferenceField>
                <EditButton/>
                <SoftDeleteWithDialogAction/>
            </Datagrid>
        </List>
    );
};
export default DownloadList;
